import React from 'react'
import BooksList from '../books/BooksList'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const EbooksList: React.FC<Props> = ({ }: Props) => {
    return (
        <BooksList
            library_category_name={ELibraryCategory.E_BOOK}
            category_label='E-Book'
            category_path={routeName.e_library.e_books}
            path_detail={routeName.e_library.e_books_detail}
        />
    )
}

export default EbooksList